function e(e, t, n) {
  e.addEventListener("message", function (r) {
    var o = r.data,
      a = o.id;
    if ("RPC" === o.type && null != a) if (o.method) {
      var s = t[o.method];
      null == s ? e.postMessage({
        type: "RPC",
        id: a,
        error: "NO_SUCH_METHOD"
      }) : Promise.resolve().then(function () {
        return s.apply(null, o.params);
      }).then(function (t) {
        e.postMessage({
          type: "RPC",
          id: a,
          result: t
        });
      }).catch(function (t) {
        e.postMessage({
          type: "RPC",
          id: a,
          error: "" + t
        });
      });
    } else {
      var i = n[a];
      if (null == i) throw Error("Unknown callback " + a);
      delete n[a], o.error ? i[1](Error(o.error)) : i[0](o.result);
    }
  });
}
export default function (t, n) {
  var r = {},
    o = "__xpo" + Math.random().toString().substring(2) + "__";
  "function" == typeof t && (t = "(" + Function.prototype.toString.call(t) + ")(" + o + ")"), t = function (e, t, n) {
    return e = (e = e.replace(/^(\s*)export\s+default\s+/m, function (e, r) {
      return n.default = !0, "" + r + t + ".default=";
    })).replace(/^(\s*)export\s+((?:async\s*)?function(?:\s*\*)?|const|let|var)(\s+)([a-zA-Z$_][a-zA-Z0-9$_]*)/gm, function (e, r, o, a, s) {
      return n[s] = !0, "" + r + t + "." + s + "=" + o + a + s;
    }), "var " + t + "={};\n" + e + "\n" + t + ";";
  }(t, o, r) + "\n(" + Function.prototype.toString.call(e) + ")(self," + o + ",{})";
  var a,
    s = URL.createObjectURL(new Blob([t], {
      type: "text/javascript"
    })),
    i = new Worker(s, n),
    c = i.terminate,
    l = {},
    u = 0;
  for (a in i.kill = function (e) {
    i.postMessage({
      type: "KILL",
      signal: e
    }), setTimeout(i.terminate);
  }, i.terminate = function () {
    URL.revokeObjectURL(s), c.call(i);
  }, i.call = function (e, t) {
    return new Promise(function (n, r) {
      var o = "rpc" + ++u;
      l[o] = [n, r], i.postMessage({
        type: "RPC",
        id: o,
        method: e,
        params: t
      });
    });
  }, i.rpcMethods = {}, e(i, i.rpcMethods, l), i.expose = function (e) {
    i[e] = function () {
      return i.call(e, [].slice.call(arguments));
    };
  }, r) a in i || i.expose(a);
  return i;
}
;